/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Notes_Save_ErrorInputs */

const en_notes_save_error = /** @type {(inputs: Notes_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The note could not be saved: ${i?.message}`)
};

const pt_br2_notes_save_error = /** @type {(inputs: Notes_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível salvar a anotação: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "The note could not be saved: {message}" |
*
* @param {Notes_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_save_error = /** @type {((inputs: Notes_Save_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Save_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_save_error(inputs)
	return pt_br2_notes_save_error(inputs)
});